import React from 'react';
import { Education as EducationType } from '../types/ProfileTypes';

interface EducationProps {
  data: EducationType[] | undefined;
}

const formatDate = (date: string | { year: number; month?: number; day?: number } | undefined | null): string => {
  if (!date) return 'Present';
  if (typeof date === 'string') {
    return new Date(date).toLocaleString('en-US', { month: 'short', year: 'numeric' });
  }
  const { year, month } = date;
  return `${month ? new Date(year, month - 1).toLocaleString('en-US', { month: 'short' }) : ''} ${year}`;
};

const Education: React.FC<EducationProps> = ({ data }) => {
  if (!data || data.length === 0) return null;

  return (
    <section className="bg-gray-800 shadow-lg rounded-lg p-6">
      <h2 className="text-2xl font-bold mb-4 text-white">Education</h2>
      <div className="space-y-6">
        {data.map((edu, index) => (
          <div key={index} className="border-b border-gray-700 pb-6 last:border-b-0 last:pb-0">
            <h3 className="text-xl font-semibold text-white">{edu.school}</h3>
            {edu.degree && <p className="text-gray-300">{edu.degree}</p>}
            {edu.fieldOfStudy && <p className="text-gray-300">{edu.fieldOfStudy}</p>}
            <p className="text-gray-300">
              {formatDate(edu.startDate)} - {formatDate(edu.endDate)}
            </p>
            {edu.activities && <p className="text-gray-400 mt-2">{edu.activities}</p>}
            {edu.description && <p className="text-gray-400 mt-2">{edu.description}</p>}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Education;